import './Configuracoes.css';
const SettingsSection = ({
    unitLogo,
    handleFileChange,
    unitAddress,
    setUnitAddress,
    unitMapsUrl,
    setUnitMapsUrl,
    unitWhatsapp,
    setUnitWhatsapp,
    unitInstagram,
    setUnitInstagram,
    revenueGoal,
    setRevenueGoal,
    unitHours,
    setUnitHours,
    handleSaveUnitConfig,
    newClosedDay,
    setNewClosedDay,
    newClosedReason,
    setNewClosedReason,
    handleAddClosedDay,
    systemBlocks,
    handleDeleteClosedDay
}) => {
    return (
        <div className="section-settings fade-in">
            <div className="admin-grid-layout">
                <div className="admin-card">
                    <h3 className="card-title">Configurações da Unidade</h3>
                    <div className="modern-form">
                        <div className="form-group">
                            <label>Logo da Unidade</label>
                            <div className="logo-upload-box" onClick={() => document.getElementById('logo-file').click()}>
                                {unitLogo ? (
                                    <div className="logo-preview-wrapper">
                                        <img src={unitLogo} alt="Logo" />
                                        <div className="upload-overlay"><span>Alterar Logo</span></div>
                                    </div>
                                ) : (
                                    <div className="logo-placeholder">Upload Logo</div>
                                )}
                            </div>
                            <input
                                type="file"
                                id="logo-file"
                                style={{ display: 'none' }}
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, 'logo')}
                            />
                        </div>
                        <div className="form-group">
                            <label>Endereço Completo</label>
                            <input
                                type="text"
                                value={unitAddress}
                                onChange={(e) => setUnitAddress(e.target.value)}
                                className="modern-input"
                            />
                        </div>
                        <div className="form-group">
                            <label>Link Google Maps</label>
                            <input
                                type="text"
                                value={unitMapsUrl}
                                onChange={(e) => setUnitMapsUrl(e.target.value)}
                                className="modern-input"
                            />
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>WhatsApp (Link)</label>
                                <input type="text" value={unitWhatsapp} onChange={(e) => setUnitWhatsapp(e.target.value)} className="modern-input" />
                            </div>
                            <div className="form-group">
                                <label>Instagram (@)</label>
                                <input type="text" value={unitInstagram} onChange={(e) => setUnitInstagram(e.target.value)} className="modern-input" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Meta de Faturamento Mensal (R$)</label>
                            <input
                                type="number"
                                value={revenueGoal}
                                onChange={(e) => setRevenueGoal(e.target.value)}
                                className="modern-input"
                            />
                        </div>
                        <div className="form-group">
                            <label>Horário de Funcionamento (uma linha por dia)</label>
                            <textarea
                                value={unitHours}
                                onChange={(e) => setUnitHours(e.target.value)}
                                className="modern-input"
                                rows="5"
                            />
                        </div>
                        <button className="modern-btn primary full-width" onClick={handleSaveUnitConfig}>
                            Salvar Alterações
                        </button>
                    </div>
                </div>

                <div className="admin-card">
                    <h3 className="card-title">Folgas e Feriados</h3>
                    <p className="card-description">Escolha um dia para fechar a barbearia e bloquear agendamentos.</p>

                    <div className="modern-form">
                        <div className="form-row">
                            <div className="form-group">
                                <label>Data para Fechar</label>
                                <input
                                    type="date"
                                    className="modern-input"
                                    value={newClosedDay}
                                    onChange={(e) => setNewClosedDay(e.target.value)}
                                    min={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                            <div className="form-group">
                                <label>Motivo (Ex: Feriado)</label>
                                <input
                                    type="text"
                                    className="modern-input"
                                    placeholder="Motivo interno..."
                                    value={newClosedReason}
                                    onChange={(e) => setNewClosedReason(e.target.value)}
                                />
                            </div>
                        </div>
                        <button
                            className="modern-btn primary full-width"
                            onClick={handleAddClosedDay}
                            disabled={!newClosedDay}
                        >
                            Confirmar Fechamento
                        </button>
                    </div>

                    <div className="closed-days-list-wrapper">
                        <h4 className="sub-title-sm">Dias Fechados no Sistema</h4>
                        <div className="closed-days-list">
                            {systemBlocks && systemBlocks.length > 0 ? (
                                systemBlocks
                                    .filter(b => b.date >= new Date().toISOString().split('T')[0])
                                    .sort((a, b) => a.date.localeCompare(b.date))
                                    .map(block => (
                                        <div key={block.id} className="closed-day-item">
                                            <div className="date-text-group">
                                                <span className="closed-date-main">{block.date.split('-').reverse().join('/')}</span>
                                                <span className="closed-reason-tag">{block.reason || 'S/ Motivo'}</span>
                                            </div>
                                            <button
                                                className="remove-closed-btn"
                                                onClick={() => handleDeleteClosedDay(block.id)}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))
                            ) : (
                                <p className="empty-list-text">Nenhum dia fechado registrado.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsSection;
